import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { RectangleWithRadius } from "../../utils/RectangleWithRadius";
import { AudioManager } from "../../AudioManager";

export class CreditsState extends Phaser.State {
    
    public create(): void {

        this.stage.disableVisibilityChange = true;

        const backgroundImage = this.add.image( GameConstants.GAME_WIDTH / 2, GameConstants.GAME_HEIGHT / 2, "lawn-background");
        backgroundImage.anchor.set(.5);
        backgroundImage.scale.setTo(1.65, 1.65 * GameVars.scaleY);

        const scaledItemsContainer = this.add.group();
        scaledItemsContainer.scale.y = GameVars.scaleY;

        const rectangleWithRadius = new RectangleWithRadius(this.game, 70, 20, GameConstants.GAME_WIDTH - 140, 720 , 40,
            "#ffffff", 0.35, null, 3);
        scaledItemsContainer.add(rectangleWithRadius);

        // el titulo
        let blackGradientRectangle: Phaser.Sprite = new Phaser.Sprite(this.game, 0, 60, this.game.cache.getBitmapData("dark_gradient"));
        blackGradientRectangle.scale.set(58, 1.7);
        scaledItemsContainer.add(blackGradientRectangle);

        let sceneTitleLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 68, " CREDITS ", {font: "85px whoopass", fill: "#DAE9E9"});
        sceneTitleLabel.anchor.x = .5;
        scaledItemsContainer.add(sceneTitleLabel);

        // el texto con la gente que lo ha hecho
        let text = new Phaser.Text(this.game, 115, 190, " A GAME BY RAVALMATIC ", {font: "50px whoopass", fill: "#DAE9E9"});
        text.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        scaledItemsContainer.add(text);

        text = new Phaser.Text(this.game, 100, 270, " AUDIO: PULMON BEATBOX ", {font: "35px whoopass", fill: "#DAE9E9"});
        text.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        scaledItemsContainer.add(text);

        text = new Phaser.Text(this.game, 100, 270 + 1 * 56, " LEVEL DESIGN: IVAN MESA ", {font: "35px whoopass", fill: "#DAE9E9"});
        text.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        scaledItemsContainer.add(text);

        text = new Phaser.Text(this.game, 100, 270 + 2 * 56, " TESTING: SERGI GRACIA ", {font: "35px whoopass", fill: "#DAE9E9"});
        text.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        scaledItemsContainer.add(text);

        text = new Phaser.Text(this.game, 100, 270 + 3 * 56, " ART & UX: JAVI SANZ ", {font: "35px whoopass", fill: "#DAE9E9"});
        text.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        scaledItemsContainer.add(text);

        text = new Phaser.Text(this.game, 100, 270 + 4 * 56, " CODE & GAME DESIGN: ENRIQUETO ", {font: "35px whoopass", fill: "#DAE9E9"});
        text.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        scaledItemsContainer.add(text);

        text = new Phaser.Text(this.game, 100, 270 + 6 * 56, " PHYSICS ENGINE: P2.JS ", {font: "35px whoopass", fill: "#DAE9E9"});
        text.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        scaledItemsContainer.add(text);

        text = new Phaser.Text(this.game, 100, 270 + 7 * 56, " GAME FRAMEWORK: PHASER ", {font: "35px whoopass", fill: "#DAE9E9"});
        text.setShadow(2, 2, "rgba(0,0,0,1)", 0);
        scaledItemsContainer.add(text);

        const backButton = this.add.button(90, GameConstants.GAME_HEIGHT - 130 * GameVars.scaleY, "texture_atlas_5", this.onClickBackButton, this, 1, 0, 1);
        backButton.setFrames("exit_button_on", "exit_button_off", "exit_button_on");
        backButton.anchor.set(.5);
        backButton.scale.y = GameVars.scaleY;

        // una etiqueta con la version del juego
        const versionLabel = this.add.text(GameConstants.GAME_WIDTH - 10, GameConstants.GAME_HEIGHT - 50 * GameVars.scaleY, "V" + GameConstants.VERSION, {font: "35px Ubuntu Condensed", fill: "#000000"});
        versionLabel.anchor.x = 1;
        versionLabel.scale.y = GameVars.scaleY;

        this.game.camera.flash(0x000000, 250);
    }

    private onClickBackButton(): void {

        this.game.state.start("SplashState", true, false);

        AudioManager.getInstance().playEffect("play");
    }
}
